module.exports = __webpack_public_path__ + "static/img/routine-01.5401f47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/routine-01.jpg
// module id = 288
// module chunks = 1